
const digest = 'd7b1c489bf75988156da418e46d2b69e9f35e7dadd5e7c85b9f5df692476fd81';
const classes = {"wrapper":"_wrapper_dxkm7_1","searchWrapper":"_searchWrapper_dxkm7_6"};
const css = `._wrapper_dxkm7_1 {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
._wrapper_dxkm7_1 ._searchWrapper_dxkm7_6 {
  flex: 1;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  